import React from 'react'
import Fade from 'react-reveal/Fade'
import { SubtitleContainer, StyledImage, StyledContent } from './Content.css'
import VideoPlayer from '../VideoPlayer'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const Subcontent = ({ image, video, excerpt, seemore }) => {
  return (
    <SubtitleContainer>
      {video &&
        <VideoPlayer url={video} />
      }
      {!video && image && image.localFile &&
        <StyledImage fluid={image.localFile.childImageSharp.fluid} />
      }
      {excerpt &&
        <StyledContent>
          <Fade bottom>
            <div className="excerpt" dangerouslySetInnerHTML={{ __html: excerpt }} />
          </Fade>
          {seemore &&
            <Fade bottom>
              <div className="btnicon">
                <span>Ver más</span>
                <FontAwesomeIcon icon={['fas', 'chevron-down']} />
              </div>
            </Fade>
          }
        </StyledContent>
      }
    </SubtitleContainer>
  )
}

export default Subcontent